import {MAINTANCE_STATUS_CODE} from "@/src/shared/const";

const isMaintanceStatusCode = (error: Error) => {
    const statusCode = error.message.match(/\b\d{3}\b/)?.[0];
    return statusCode === MAINTANCE_STATUS_CODE
}

export { isMaintanceStatusCode }
